export { default } from './Home24ConhecerFinanciamento';
